module.exports = __webpack_public_path__ + "7a6a81e07f44a530eaba2e588c71fbed.MP3";